<template>
    <v-container fluid class="px-0">
      <v-card outlined class="my-0">
        <v-card-title style="padding: 0.5rem 1rem">
          <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
            <v-col cols="4"
              ><v-icon>{{
                isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
              }}</v-icon>
              {{ $t('Filtras') }}</v-col
            >
          </v-row>
        </v-card-title>
        <v-expand-transition>
          <v-card-text class="pt-1" v-if="isExpanded">
            <form @keydown.enter.prevent="submit()">
              <v-row class="mb-0 pb-0">
                <v-col cols="12" md="6">
                  <el-autocomplete
                    v-model="mainData['jar_fact_sub_type_id-search-in']"
                    :items="jarFacts"
                    itemvalue="code_pair"
                    itemtext="text"
                    label="JAR faktas"
                    multiple
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <el-autocomplete
                    v-model="mainData['kada_jar_role_id-search-custom']"
                    :items="jarIpasasRoles"
                    itemvalue="value"
                    itemtext="text"
                    label="iPasas vaidmuo"
                    multiple
                  />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <el-button
                    class="mr-1"
                    title="Ieškoti"
                    :loading="loading"
                    color="primary"
                    icon="ieškoti"
                    @click.native.stop="searchData(true)"
                  />
                  <el-button
                    color="secondary"
                    icon="išvalyti"
                    title="Išvalyti"
                    :loading="loading"
                    @click.native="clearData()"
                  />
                </v-col>
              </v-row>
            </form>
          </v-card-text>
        </v-expand-transition>
      </v-card>
    </v-container>
  </template>
  
  <script>
  import { mapGetters } from 'vuex'
  
  export default {
    name: 'JarFactIpasRoleSearch',
    props: {
      loading: Boolean,
      jarFacts: Object,
      jarIpasasRoles: Object,
    },
    data: () => ({
      mainData: {},
    }),
    computed: {
      ...mapGetters(['searchParams']),
      isExpanded() {
        if (this.mainData.isExpanded == null) {
          this.$set(this.mainData, 'isExpanded', false)
        }
        return this.mainData.isExpanded
      },
    },
    inject: {
      $validator: '$validator',
    },
    created() {
      this.getSearchParams()
      this.searchData()
    },
    methods: {
      setExpanded() {
        let logic = !this.mainData.isExpanded
        this.$set(this.mainData, 'isExpanded', logic)
      },
      getSearchParams() {
        if (this.searchParams && this.searchParams.route === this.$route.name) {
          this.mainData = this.searchParams.mainData
        }
      },
      searchData(button) {
        let searchData = { ...this.mainData }
        this.$store.dispatch('searchParams', {
          route: this.$route.name,
          mainData: this.mainData,
        })
        searchData.btn = button
        this.$emit('search', searchData)
      },
      clearData() {
        this.mainData = {isExpanded: true, clear: true }
        this.$nextTick(() => {
          this.mainData = { isExpanded: true }
          this.searchData(true)
        })
      },
      submit() {
        this.searchData(true)
      },
    },
  }
  </script>
  